import React, { useState } from 'react';

import classNames from 'classnames';

import { Icon, UiButton } from '@shared/ui';

import cls from './AiGenerateButton.module.css';

interface GenerateMeasurementButtonProps {
    cb?: () => void;
    children?: React.ReactNode;
    iconName: string;
    color?: 'gradient' | 'light';
    endIcon?: React.ReactNode;
    classes?: string;
    id?: string;
}

export const AiGenerateButton = ({
    cb,
    children,
    iconName,
    color = 'gradient',
    endIcon,
    classes,
    id,
}: GenerateMeasurementButtonProps) => {
    const [isHover, setIsHover] = useState(false);

    const getIconName = (locale: string) => {
        switch (locale) {
            case 'ru':
                return 'generateMeasurementRus';

            default:
                return 'generateMeasurementEng';
        }
    };

    return (
        <UiButton
            id={id}
            onMouseMove={() => setIsHover(true)}
            onMouseOut={() => setIsHover(false)}
            className={classNames(cls.generateMeasurementButton, cls[color], classes)}
            onClick={cb}
            // @ts-ignore
            startIcon={<Icon iconName={isHover ? getIconName(LOCALE) : iconName} />}
            // @ts-ignore
            btnText={children}
            endIcon={endIcon}
        />
    );
};
